import React from 'react';
import { ErrorBoundary } from '@sentry/react';
import { I18n, I18nextProvider } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { CoreStore } from '@gamiphy/loyalty-station-desktop/store/core';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import FlagProvider, { UnleashClient } from '@unleash/proxy-client-react';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import './bootstrap';
import './sdk';
import { useLSTheme } from '@gamiphy/loyalty/theme';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { Layout } from './layout';

const App = () => {
  const muiTheme = useLSTheme({
    dir: AppStore.dir,
    coretavaTheme: ThemeStore.theme,
  });

  const unleashClient = React.useMemo(() => new UnleashClient({
    url: 'https://feature-flags.coretava.com/api/frontend',
    clientKey: process.env.UNLEASH_CLIENT_ID,
    refreshInterval: 15,
    appName: `core-loyalty-${process.env.GAMIPHY_ENV}-desktop`,
  }), []);

  React.useEffect(() => {
    if (AppStore.app) {
      void unleashClient.updateContext({
        properties: {
          appId: AppStore.app.id,
          agent: AppStore.app.agent,
        },
      });
    }
  }, [AppStore.app, unleashClient]);

  return !CoreStore.initialized ? null : (
    <React.Suspense fallback={<div />}>
      <ErrorBoundary>
        <FlagProvider
          unleashClient={unleashClient}
        >
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={muiTheme}>
              <I18nextProvider i18n={I18n.instance}>
                <Layout />
              </I18nextProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </FlagProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};

export default observer(App);
